module.exports = __webpack_public_path__ + "media/cards/11-3fbb1190.png";